import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { UserSessionType } from '../../types/user.types'
import { baseButtonTextWhiteBg } from '../../theme/custom-styles'

export const BankBalanceSquareContainer = ({
  bankName,
  mainData,
  logoImage,
  dataLoaded,
  userSession,
  secondaryData,
  hideBalanceData,
  hideSecondaryData,
  handleOpenUpdateBankBalanceModal,
  handleRedirectToBankingPartnerDetails
}: {
  mainData: string
  bankName?: string
  logoImage: string
  dataLoaded?: boolean
  secondaryData?: string
  hideBalanceData?: boolean
  hideSecondaryData?: boolean
  userSession?: UserSessionType
  handleRedirectToBankingPartnerDetails?: () => void
  handleOpenUpdateBankBalanceModal?: (bankName: string) => void
}) => {
  const { t } = useTranslation(['banks-balances-management'])
  console.log()

  return (
    <div
      className="bank-balance-square-container"
      onClick={() => handleRedirectToBankingPartnerDetails?.()}
      style={handleRedirectToBankingPartnerDetails ? { cursor: 'pointer' } : {}}
    >
      {!hideBalanceData && (
        <div className="bank-balance-square-info-container">
          {dataLoaded ? (
            <>
              <div className="bank-balance-square-main-data">{mainData}</div>
              {!hideSecondaryData && <div className="bank-balance-square-secondary-data">{secondaryData}</div>}
            </>
          ) : (
            <>
              <div
                className="data-container-loader"
                style={{ padding: '12px', width: '200px', alignSelf: 'center' }}
              ></div>
              <div
                className="data-container-loader"
                style={{ padding: '6px', width: '100px', alignSelf: 'center' }}
              ></div>
            </>
          )}
        </div>
      )}
      <img
        src={logoImage}
        alt="square-logo"
      />
      {handleOpenUpdateBankBalanceModal && (userSession?.role === 'super-admin' || userSession?.role === 'admin') && (
        <Button
          variant="text"
          sx={baseButtonTextWhiteBg}
          className="actions-bar-button-action"
          onClick={() => handleOpenUpdateBankBalanceModal?.(String(bankName))}
        >
          <div className="actions-bar-button-action-text">{t('editBalance')}</div>
        </Button>
      )}
    </div>
  )
}
